import { useState, useRef } from "react";
const Portfolio = ({ pdfFiles = [], setPdfFiles }) => { // <-- default to empty array
  const [dragOver, setDragOver] = useState(false);
  const inputId = useRef("pdfInput-" + Math.random().toString(36).slice(2));

  // Add new PDF
  const handleFileSelect = (file) => {
    if (!file || file.type !== "application/pdf") {
      alert("Only PDF files are allowed.");
      return;
    }
    setPdfFiles([...pdfFiles, file]);
  };

  // Remove PDF by index
  const handleRemove = (index) => {
    const newFiles = pdfFiles.filter((_, i) => i !== index);
    setPdfFiles(newFiles);
  };

  // Handle drag & drop
  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    handleFileSelect(file);
  };

  return (
 <div className="space-y-4">
  {/* Drag & Drop */}
  <div
    className={`border-2 border-dashed rounded-xl p-10 text-center cursor-pointer transition-all duration-200
      bg-gray-50 border-gray-300
      ${dragOver ? "border-[#0f6abf] bg-[#e8f0f7]" : "hover:border-[#0f6abf] hover:bg-[#e8f0f7]/50"}`}
    onDragOver={(e) => {
      e.preventDefault();
      setDragOver(true);
    }}
    onDragLeave={() => setDragOver(false)}
    onDrop={handleDrop}
    onClick={() => document.getElementById(inputId.current).click()}
  >
    <div className="flex flex-col items-center gap-3">
      <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-sm">
        <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      </div>
      <p className="text-gray-700 font-medium">Drag & Drop your PDFs here</p>
      <span className="text-sm text-gray-500">or</span>
      <button
        className="px-4 py-2 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
        onClick={(e) => {
          e.stopPropagation();
          document.getElementById(inputId.current).click();
        }}
      >
        Select PDF
      </button>
    </div>

    <input
      id={inputId.current}
      type="file"
      accept="application/pdf"
      hidden
      onChange={(e) => handleFileSelect(e.target.files[0])}
    />
  </div>

  {/* Show all PDFs */}
  {(pdfFiles || []).map((file, index) => {
    const pdfSrc = file instanceof File ? URL.createObjectURL(file) : file;
    return (
      <div key={index} className="relative">
        <div className="absolute -top-2 -right-2 z-10">
          <button
            className="w-8 h-8 bg-red-500 rounded-lg flex items-center justify-center text-white hover:bg-red-600 transition-colors shadow-md"
            onClick={() => handleRemove(index)}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="bg-gray-50 rounded-xl p-4">
          <iframe
            src={pdfSrc}
            className="w-full h-52 rounded-lg border-0"
          ></iframe>
        </div>
      </div>
    );
  })}
</div>

  );
};

export default Portfolio;
